// extracted by mini-css-extract-plugin
export default {"root":"DashboardRowDeposit_root__2CWuD","labelWithTooltip":"DashboardRowDeposit_labelWithTooltip__UatFs","tooltip":"DashboardRowDeposit_tooltip__LCYXp"};